module.exports = __webpack_public_path__ + "img/upgraded_staking.c0271180.jpeg";